import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.js";
import consultationsData from "./ConsultationPage/consultationsData.js";
import useSEO from "../hooks/useSEO.js";
import seoConfig from "../hooks/seoConfig.js";

export default function Services() {
  useSEO(seoConfig.services);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title">
        Медицинские услуги УрНИИДВиИ в Екатеринбурге
      </h1>

      <p className="dissertation__text">
        ГБУ СО «УрНИИДВиИ» в Екатеринбурге предоставляет медицинские услуги по
        профилю учреждения. На этой странице вы можете ознакомиться с перечнем
        услуг, узнать об их назначении, посмотреть информацию о специалистах и
        уточнить стоимость по действующему прейскуранту.
      </p>

      <p className="dissertation__text">
        Чтобы быстрее найти нужную услугу, выберите её из списка ниже. На
        отдельной странице услуги размещена дополнительная информация, в том
        числе сведения о специализации врача, условиях оказания услуги и порядке
        записи, если такие сведения предусмотрены для конкретной позиции.
      </p>

      <h2
        id="services-list-title"
        className="about-nii__title antiCorruption__title"
      >
        Перечень медицинских услуг
      </h2>

      <ul className="list">
        {consultationsData.map((service) => (
          <li className="privacy__text">
            <Link
              key={service.slug}
              to={`/services/${service.slug}`}
              className="staff-card__link"
            >
              {service.title}
            </Link>
          </li>
        ))}
      </ul>

      <h2 className="about-nii__title antiCorruption__title">
        Как выбрать нужную медицинскую услугу
      </h2>

      <p className="dissertation__text">
        При выборе услуги ориентируйтесь на её название и описание. Если вы
        ищете консультацию определённого специалиста, обратите внимание на
        указанную специализацию. Если вам необходимо диагностическое или
        лечебное вмешательство, предварительно уточните, требуется ли
        консультация врача и какие документы или результаты обследований следует
        взять с собой.
      </p>

      <p className="dissertation__text">
        Если вы не уверены, какая услуга вам необходима, не выбирайте
        медицинское вмешательство самостоятельно. Уточните порядок обращения у
        регистратуры или обсудите вопрос с медицинским специалистом.
      </p>

      <h2 className="about-nii__title antiCorruption__title">
        Стоимость медицинских услуг
      </h2>

      <p className="dissertation__text">
        Стоимость услуг определяется действующим прейскурантом учреждения. На
        странице конкретной услуги можно посмотреть указанную цену и
        дополнительную информацию об условиях её оказания.
      </p>

      <p className="dissertation__text">
        Перед посещением рекомендуем уточнить актуальную стоимость, доступность
        услуги, необходимость предварительной записи и другие организационные
        условия.
      </p>

      <p className="dissertation__text">
        Полный перечень цен доступен в разделе{" "}
        <Link className="staff-card__link" to="/patients/price-list">
          «Прейскурант медицинских услуг»
        </Link>
        .
      </p>

      <h2 className="about-nii__title antiCorruption__title">
        Специалисты и запись на приём
      </h2>

      <p className="dissertation__text">
        Информация о врачах и специалистах учреждения представлена в
        соответствующем разделе сайта. Вы можете ознакомиться с профилем
        специалиста и уточнить возможность записи на необходимую услугу.
      </p>

      <p className="dissertation__text">
        Для уточнения порядка обращения, доступного времени приёма и условий
        получения медицинской помощи перейдите на страницу{" "}
        <Link className="staff-card__link" to="/patients/reception">
          «Запись на приём»
        </Link>
        .
      </p>

      <p className="dissertation__text">
        Список врачей, расписание и возможность записи могут изменяться.
        Актуальную информацию о приёме конкретного специалиста рекомендуется
        уточнять перед посещением.
      </p>

      <p className="dissertation__text">
        <Link className="staff-card__link" to="/patients/specialists">
          Посмотреть всех врачей и специалистов
        </Link>
      </p>

      <h2 className="about-nii__title antiCorruption__title">
        Контактная информация
      </h2>

      <p className="dissertation__text">
        Если у вас остались вопросы о перечне медицинских услуг, порядке записи
        или подготовке к посещению, воспользуйтесь контактной информацией
        учреждения.
      </p>

      <p className="dissertation__text">
        <Link className="staff-card__link" to="/patients/pay">
          Информация о платных медицинских услугах
        </Link>
      </p>

      <p className="dissertation__text">
        <Link className="staff-card__link" to="/contacts">
          Контакты УрНИИДВиИ, адрес и схема проезда
        </Link>
      </p>

      <h2 className="about-nii__title antiCorruption__title">
        Важная информация для пациентов
      </h2>

      <p className="dissertation__text">
        Информация на сайте носит справочный характер и не заменяет консультацию
        медицинского специалиста. Необходимость обследования, лечения или иной
        медицинской услуги определяется индивидуально с учётом состояния
        пациента и медицинских показаний.
      </p>
    </section>
  );
}
